<template lang="">
  <div>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 53.66 53.66">
  <g id="Reserve_a_Vehicle" data-name="Reserve a Vehicle" transform="translate(-719.813 -489.701)">
    <g id="Group_27684" data-name="Group 27684">
      <circle id="Ellipse_1081" data-name="Ellipse 1081" cx="26.33" cy="26.33" r="26.33" transform="translate(720.313 490.201)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
    </g>
    <g id="Group_8650" data-name="Group 8650" transform="translate(733.003 502.277)">
      <circle id="Ellipse_978" data-name="Ellipse 978" cx="13.822" cy="13.822" r="13.822" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
      <line id="Line_931" data-name="Line 931" x1="6.873" y2="7.93" transform="translate(11.479 9.858)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
      <line id="Line_932" data-name="Line 932" x2="3.172" y2="3.701" transform="translate(8.157 14.149)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
    </g>
  </g>
</svg>

  </div>
</template>
<script>
export default {
  props: {
    themeColor: {
      type: String,
      default: '#B3B3B3'
    },
    height: {
      type: String,
      default: '53.66px'
    },
    width: {
      type: String,
      default: '53.66px'
    }
  }
}
</script>
<style lang="">

</style>
